















































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AuthModule from '@/store/modules/Auth';
import utils from '@/services/utils';

@Component
export default class DownlineBody extends Vue {
  AuthInstance = getModule(AuthModule, this.$store);

  @Prop() readonly data!: object;

  @Prop() readonly report!: Function;

  @Prop() readonly lock!: Function;

  @Prop() readonly editInfo!: Function;

  @Prop() readonly resetPassword!: Function;

  @Prop() readonly editPT!: Function;

  @Prop() readonly refillCredit!: Function;

  @Prop() readonly deductCredit!: Function;

  @Prop() readonly handleSub!: Function;

  @Prop() readonly startCount!: number;

  @Prop() readonly showFilterCurrency!: boolean;

  @Prop() readonly currencyRate!: any;

  editAgent(user) {
    this.$router.push({ name: 'EditAgent', params: { user } });
  }

  editMember(user) {
    this.$router.push({ name: 'EditMember', params: { user } });
  }

  isSuspend(user) {
    if (user.isSuspend) {
      return 'isSuspend';
    } else {
      return '';
    }
  }

  calRate(value: number, currency: any) {
    return (value / this.currencyRate[currency]);
  }

  convertBalance(num) {
    return num && num.$numberDecimal ? num.$numberDecimal : num;
  }

  checkPerm = utils.getUserPersistent().user.userPermission.member === 'edit';

  isAdmin = ['SUPERADMIN', 'ADMIN'].includes(this.AuthInstance.user.role)
}
